import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCalendar, MatCalendarCellClassFunction } from '@angular/material/datepicker';
import { DateService } from 'services/date.service';

@Component({
	selector: 'date-picker',
	templateUrl: './date-picker.component.html',
	styleUrls: ['./date-picker.component.scss'],
	imports: [MatCalendar]
})

export class DatePickerComponent {

	constructor(private readonly dateService: DateService) { }
	
	selectedDate: Date | null = null;

	@Output() modelChange = new EventEmitter<Date>();

	@Input()
	set model(date: Date | null) {
		this.selectedDate = this.convertToLocalDate(date)!;
	}
	get model() {
		return this.selectedDate;
	}

	@Input() minDate?: Date;
	@Input() maxDate?: Date;

	@Input()
	set markedDates(dates: Date[]) {
		this._markedDates = [];
		if (!dates) return;
		for (let i = 0; i < dates.length; i++) {
			this._markedDates.push(this.dateService.getDate(dates[i]));
		}
	}
	private _markedDates: Date[] = [];

	@Input()
	suggestedMinDate: Date | null = null;

	convertToLocalDate(date: Date | null): Date | null{
		if (!date) return null;
		let offset = new Date().getTimezoneOffset();
		let localDate = new Date(date);
		localDate = new Date(localDate.setUTCMinutes(localDate.getMinutes() - offset));
		return new Date(localDate.getFullYear(), localDate.getMonth(), localDate.getDate());
	}

	updateSelectedDate() {
		this.modelChange.emit(this.selectedDate ?? undefined);
	}

	dateClass: MatCalendarCellClassFunction<Date> = (date, view) => {
		let classes = '';
		const day = date.getDay();

		if (view === 'month' && day === 6 || day === 0) {
			classes += 'weekend-date';
		}
		if (this._markedDates.find(d => this.dateService.getDate(d).getTime() == this.dateService.getDate(date).getTime())) {
			classes += ' marked';
		}
		else if (this.suggestedMinDate != null && this.dateService.getDate(this.suggestedMinDate).getTime() > this.dateService.getDate(date).getTime()) {
			classes += ' discouraged';
		}

		return classes;
	};
}
